module.exports = __webpack_public_path__ + "img/CAMBODIA-CockFight.57d81930.png";